
import { useState } from 'react';
import Header from '../home/components/Header';
import TabBar from '../home/components/TabBar';

export default function Ships() {
  const [activeTab, setActiveTab] = useState('home');
  const [selectedSubcategory, setSelectedSubcategory] = useState<number | null>(null);
  const [selectedTransactionType, setSelectedTransactionType] = useState<string | null>(null);

  const transactionTypes = [
    { id: 'sale', name: 'للبيع', icon: 'ri-price-tag-3-line', color: 'bg-green-500' },
    { id: 'rent', name: 'للإيجار', icon: 'ri-calendar-line', color: 'bg-blue-500' },
    { id: 'wanted', name: 'مطلوب', icon: 'ri-search-line', color: 'bg-orange-500' },
    { id: 'exchange', name: 'للبدل', icon: 'ri-exchange-line', color: 'bg-purple-500' }
  ];

  const subcategories = [
    { id: 31, name: 'اليخوت الفاخرة', count: '4 مزاد', icon: 'ri-ship-line' },
    { id: 32, name: 'القوارب السريعة', count: '3 مزاد', icon: 'ri-sailboat-line' },
    { id: 33, name: 'سفن الصيد', count: '2 مزاد', icon: 'ri-anchor-line' },
    { id: 34, name: 'القوارب الشراعية', count: '2 مزاد', icon: 'ri-sailboat-fill' },
    { id: 35, name: 'سفن أخرى', count: '1 مزاد', icon: 'ri-ship-2-line' }
  ];

  const shipsAuctions = [
    {
      id: 1,
      title: 'يخت فاخر 80 قدم',
      brand: 'أزيموت',
      year: 2020,
      length: '24 متر',
      engines: 'محركين ديزل',
      cabins: 4,
      currentBid: '3,200,000',
      image: 'https://public.readdy.ai/ai/img_res/aa1ac8095b1ebd9fdb5bf8f7c41444b1.jpg',
      bidders: 6,
      category: 'اليخوت الفاخرة',
      transactionType: 'sale',
      timeLeft: { hours: 3, minutes: 20, seconds: 45 }
    },
    {
      id: 2,
      title: 'قارب سريع فيراري للإيجار',
      brand: 'فيراري',
      year: 2021,
      length: '15 متر',
      engines: 'محرك واحد قوي',
      maxSpeed: '120 كم/ساعة',
      currentBid: '15,000',
      image: 'https://readdy.ai/api/search-image?query=Ferrari%20speedboat%20luxury%20racing%20boat%2C%20red%20and%20white%20design%2C%20high-performance%20marine%20vessel%2C%20professional%20boat%20photography%2C%20sleek%20aerodynamic%20design%2C%20premium%20sports%20boat%2C%20ocean%20racing%20yacht%2C%20sophisticated%20marine%20engineering&width=300&height=200&seq=speedboat1&orientation=landscape',
      bidders: 12,
      category: 'القوارب السريعة',
      transactionType: 'rent',
      timeLeft: { hours: 1, minutes: 45, seconds: 20 }
    },
    {
      id: 3,
      title: 'يخت شراعي كلاسيكي',
      brand: 'بافاريا',
      year: 2019,
      length: '18 متر',
      sails: 'أشرعة كاملة',
      cabins: 3,
      currentBid: '420,000',
      image: 'https://readdy.ai/api/search-image?query=Classic%20sailing%20yacht%20Bavaria%20brand%2C%20elegant%20white%20sailboat%20with%20full%20sails%2C%20professional%20sailing%20photography%2C%20traditional%20yacht%20design%2C%20premium%20sailing%20vessel%2C%20ocean%20sailing%2C%20sophisticated%20marine%20craftsmanship%2C%20blue%20ocean%20background&width=300&height=200&seq=sailboat1&orientation=landscape',
      bidders: 8,
      category: 'القوارب الشراعية',
      transactionType: 'sale',
      timeLeft: { hours: 5, minutes: 10, seconds: 30 }
    },
    {
      id: 4,
      title: 'مطلوب سفينة صيد تجارية',
      brand: 'نورسيا',
      year: 2018,
      length: '22 متر',
      capacity: '50 طن',
      equipment: 'معدات صيد كاملة',
      currentBid: '680,000',
      image: 'https://readdy.ai/api/search-image?query=Commercial%20fishing%20vessel%20Norsia%20brand%2C%20professional%20fishing%20boat%2C%20marine%20commercial%20vessel%2C%20fishing%20equipment%20on%20deck%2C%20sturdy%20boat%20design%2C%20working%20vessel%20photography%2C%20ocean%20fishing%20boat%2C%20industrial%20marine%20vessel&width=300&height=200&seq=fishing1&orientation=landscape',
      bidders: 4,
      category: 'سفن الصيد',
      transactionType: 'wanted',
      timeLeft: { hours: 7, minutes: 30, seconds: 15 }
    },
    {
      id: 5,
      title: 'يخت ميجا فاخر للبدل',
      brand: 'سانلورينزو',
      year: 2022,
      length: '36 متر',
      engines: 'ثلاثة محركات',
      cabins: 6,
      crew: 8,
      currentBid: '8,500,000',
      image: 'https://readdy.ai/api/search-image?query=Mega%20yacht%20120%20feet%20Sanlorenzo%20brand%2C%20ultra-luxury%20superyacht%2C%20premium%20white%20yacht%20design%2C%20professional%20luxury%20marine%20photography%2C%20sophisticated%20yacht%20architecture%2C%20high-end%20vessel%2C%20pristine%20ocean%20setting%2C%20elegant%20yacht%20styling&width=300&height=200&seq=megayacht1&orientation=landscape',
      bidders: 3,
      category: 'اليخوت الفاخرة',
      transactionType: 'exchange',
      timeLeft: { hours: 12, minutes: 45, seconds: 55 }
    },
    {
      id: 6,
      title: 'قارب رياضي مائي',
      brand: 'سي راي',
      year: 2021,
      length: '8 متر',
      engines: 'محرك واحد',
      activities: 'تزلج مائي وغوص',
      currentBid: '180,000',
      image: 'https://readdy.ai/api/search-image?query=Sea%20Ray%20sports%20boat%2C%20water%20sports%20vessel%2C%20recreational%20boat%20photography%2C%20premium%20leisure%20boat%2C%20water%20skiing%20boat%2C%20diving%20boat%2C%20marine%20recreation%20vessel%2C%20professional%20boat%20photography%2C%20clear%20blue%20water&width=300&height=200&seq=sportsboat1&orientation=landscape',
      bidders: 15,
      category: 'القوارب السريعة',
      transactionType: 'sale',
      timeLeft: { hours: 2, minutes: 15, seconds: 40 }
    }
  ];

  const filteredAuctions = shipsAuctions.filter(auction => {
    const matchesSubcategory = selectedSubcategory 
      ? auction.category === subcategories.find(sub => sub.id === selectedSubcategory)?.name
      : true;
    
    const matchesTransactionType = selectedTransactionType 
      ? auction.transactionType === selectedTransactionType
      : true;
    
    return matchesSubcategory && matchesTransactionType;
  });

  const getTransactionTypeLabel = (type: string) => {
    const transactionType = transactionTypes.find(t => t.id === type);
    return transactionType ? transactionType.name : '';
  };

  const getTransactionTypeColor = (type: string) => {
    const transactionType = transactionTypes.find(t => t.id === type);
    return transactionType ? transactionType.color : 'bg-gray-500';
  };

  return (
    <div className="min-h-screen bg-black text-white" style={{ fontFamily: 'Cairo, sans-serif' }}>
      <Header />
      
      <main className="pt-16 pb-20">
        <div className="px-4 py-6">
          <div className="flex items-center mb-6">
            <button 
              onClick={() => window.history.back()}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-900 ml-3"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
            <div>
              <h1 className="text-xl font-bold">السفن</h1>
              <p className="text-sm text-gray-400">12 مزاد متاح</p>
            </div>
          </div>

          {/* Transaction Types Filter */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-4">نوع المعاملة</h3>
            <div className="flex overflow-x-auto pb-2 space-x-3 space-x-reverse">
              <button
                onClick={() => setSelectedTransactionType(null)}
                className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  selectedTransactionType === null 
                    ? 'bg-yellow-400 text-black' 
                    : 'bg-gray-900 text-white hover:bg-gray-800'
                }`}
              >
                الكل
              </button>
              {transactionTypes.map((type) => (
                <button
                  key={type.id}
                  onClick={() => setSelectedTransactionType(type.id)}
                  className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors flex items-center ${
                    selectedTransactionType === type.id 
                      ? 'bg-yellow-400 text-black' 
                      : 'bg-gray-900 text-white hover:bg-gray-800'
                  }`}
                >
                  <i className={`${type.icon} ml-1`}></i>
                  {type.name}
                </button>
              ))}
            </div>
          </div>

          {/* Subcategories Filter */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-4">أنواع السفن</h3>
            <div className="flex overflow-x-auto pb-2 space-x-3 space-x-reverse">
              <button
                onClick={() => setSelectedSubcategory(null)}
                className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  selectedSubcategory === null 
                    ? 'bg-yellow-400 text-black' 
                    : 'bg-gray-900 text-white hover:bg-gray-800'
                }`}
              >
                الكل
              </button>
              {subcategories.map((subcategory) => (
                <button
                  key={subcategory.id}
                  onClick={() => setSelectedSubcategory(subcategory.id)}
                  className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                    selectedSubcategory === subcategory.id 
                      ? 'bg-yellow-400 text-black' 
                      : 'bg-gray-900 text-white hover:bg-gray-800'
                  }`}
                >
                  {subcategory.name}
                </button>
              ))}
            </div>
          </div>

          {/* Subcategories Grid */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            {subcategories.map((subcategory) => (
              <button
                key={subcategory.id}
                onClick={() => setSelectedSubcategory(subcategory.id)}
                className="bg-gray-900 rounded-xl p-4 text-center hover:bg-gray-800 transition-colors"
              >
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-yellow-400/10 rounded-lg">
                  <i className={`${subcategory.icon} text-2xl text-yellow-400`}></i>
                </div>
                <h4 className="font-medium text-sm mb-1">{subcategory.name}</h4>
                <p className="text-xs text-gray-400">{subcategory.count}</p>
              </button>
            ))}
          </div>

          {/* Ships Auctions */}
          <div className="mb-4">
            <h3 className="text-lg font-semibold mb-4">
              {selectedSubcategory || selectedTransactionType
                ? `مزادات ${selectedSubcategory ? subcategories.find(sub => sub.id === selectedSubcategory)?.name : 'السفن'} ${selectedTransactionType ? getTransactionTypeLabel(selectedTransactionType) : ''}`
                : 'جميع مزادات السفن'
              }
            </h3>
          </div>

          <div className="space-y-4">
            {filteredAuctions.map((auction) => (
              <div key={auction.id} className="bg-gray-900 rounded-xl overflow-hidden">
                <div className="relative">
                  <img 
                    src={auction.image}
                    alt={auction.title}
                    className="w-full h-48 object-cover object-top"
                  />
                  <div className="absolute top-3 right-3 bg-red-500 text-white px-2 py-1 rounded-full text-xs font-medium flex items-center">
                    <div className="w-1.5 h-1.5 bg-white rounded-full ml-1 animate-pulse"></div>
                    مباشر
                  </div>
                  <div className="absolute top-3 left-3 flex space-x-2 space-x-reverse">
                    <div className="bg-black/70 text-white px-2 py-1 rounded-full text-xs">
                      {auction.category}
                    </div>
                    <div className={`${getTransactionTypeColor(auction.transactionType)} text-white px-2 py-1 rounded-full text-xs`}>
                      {getTransactionTypeLabel(auction.transactionType)}
                    </div>
                  </div>
                  <button className="absolute bottom-3 left-3 w-8 h-8 bg-black/70 rounded-full flex items-center justify-center">
                    <i className="ri-heart-line text-white"></i>
                  </button>
                </div>
                
                <div className="p-4">
                  <h4 className="font-semibold mb-2">{auction.title}</h4>
                  
                  <div className="flex items-center text-sm text-gray-400 mb-3">
                    <i className="ri-ship-line ml-1"></i>
                    <span>{auction.brand} - {auction.year}</span>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
                    <div className="flex items-center">
                      <i className="ri-ruler-line text-yellow-400 ml-2"></i>
                      <span>{auction.length}</span>
                    </div>
                    {auction.engines && (
                      <div className="flex items-center">
                        <i className="ri-settings-line text-yellow-400 ml-2"></i>
                        <span>{auction.engines}</span>
                      </div>
                    )}
                    {auction.cabins && (
                      <div className="flex items-center">
                        <i className="ri-hotel-bed-line text-yellow-400 ml-2"></i>
                        <span>{auction.cabins} كبائن</span>
                      </div>
                    )}
                    {auction.maxSpeed && (
                      <div className="flex items-center">
                        <i className="ri-speed-line text-yellow-400 ml-2"></i>
                        <span>{auction.maxSpeed}</span>
                      </div>
                    )}
                    {auction.capacity && (
                      <div className="flex items-center">
                        <i className="ri-weight-line text-yellow-400 ml-2"></i>
                        <span>{auction.capacity}</span>
                      </div>
                    )}
                    {auction.crew && (
                      <div className="flex items-center">
                        <i className="ri-team-line text-yellow-400 ml-2"></i>
                        <span>{auction.crew} طاقم</span>
                      </div>
                    )}
                  </div>
                  
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <p className="text-xs text-gray-400 mb-1">
                        {auction.transactionType === 'rent' ? 'الإيجار الشهري' : 'السعر الحالي'}
                      </p>
                      <p className="text-lg font-bold text-yellow-400">
                        {auction.currentBid} ر.ق
                        {auction.transactionType === 'rent' && <span className="text-sm">/شهر</span>}
                      </p>
                    </div>
                    <div className="text-left">
                      <p className="text-xs text-gray-400 mb-1">الوقت المتبقي</p>
                      <div className="flex items-center space-x-1 space-x-reverse">
                        <span className="bg-gray-800 px-2 py-1 rounded text-xs font-mono">
                          {auction.timeLeft.hours.toString().padStart(2, '0')}
                        </span>
                        <span className="text-xs">:</span>
                        <span className="bg-gray-800 px-2 py-1 rounded text-xs font-mono">
                          {auction.timeLeft.minutes.toString().padStart(2, '0')}
                        </span>
                        <span className="text-xs">:</span>
                        <span className="bg-gray-800 px-2 py-1 rounded text-xs font-mono">
                          {auction.timeLeft.seconds.toString().padStart(2, '0')}
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <i className="ri-user-line text-gray-400 ml-1"></i>
                      <span className="text-sm text-gray-400">{auction.bidders} مزايد</span>
                    </div>
                    <button className="bg-yellow-400 text-black px-6 py-2 rounded-full font-semibold text-sm">
                      {auction.transactionType === 'wanted' ? 'عرض' : 'زايد الآن'}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      
      <TabBar activeTab={activeTab} setActiveTab={setActiveTab} />
    </div>
  );
}
